
import React from 'react'
import { useEffect } from 'react';
import './agenda.css'
import Avatar from '@material-ui/core/Avatar';
import img1 from "../assets/images/lilyaN.png";
import img2 from "../assets/images/afif.jpeg";
import img3 from "../assets/images/habi.jpg";
import img4 from "../assets/images/azzize.jpg";
import img5 from "../assets/images/raouf.jpg";
import img6 from "../assets/images/hacene.jpg";
import img8 from "../assets/images/ayoub.jpg";
import img9 from "../assets/images/sofianee.png";
import img10 from "../assets/images/hadjer.jpg";
import img11 from "../assets/images/soaiblue.jpg";
import IconButton from '@material-ui/core/IconButton';
import { Container } from 'react-bootstrap';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import YouTubeIcon from '@material-ui/icons/YouTube';


export default function Agenda() {
    const [isVisible, setVisible] = React.useState(false);
    const [isVisible1, setVisible1] = React.useState(false);
    const [isVisible2, setVisible2] = React.useState(false);
    const domRef = React.useRef();
    const domRef1 = React.useRef();
    const domRef2 = React.useRef();

    useEffect(() => {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => setVisible(entry.isIntersecting));
        });
        observer.observe(domRef.current);
        const observer1 = new IntersectionObserver(entries => {
            entries.forEach(entry => setVisible1(entry.isIntersecting));
        });
        observer1.observe(domRef1.current);


        var items = document.querySelectorAll(".timeline li");
        window.scrollTo(0, 0);
        console.log(window.matchMedia("(min-width: 600px)").matches)
        if (!window.matchMedia("(min-width: 600px)").matches) {


            function isElementInViewport(el) {
                var rect = el.getBoundingClientRect();
                return (
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight + 500) &&
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            }

            function callbackFunc() {
                for (var i = 0; i < items.length; i++) {
                    if (isElementInViewport(items[i])) {
                        if (!items[i].classList.contains("in-view")) {
                            items[i].classList.add("in-view");
                        }
                    } else if (items[i].classList.contains("in-view")) {
                        items[i].classList.remove("in-view");
                    }
                }
            }
            items[0].classList.add("in-view");
            items[1].classList.add("in-view");


            window.addEventListener("load", callbackFunc);
            // window.addEventListener("scroll", callbackFunc);
            window.addEventListener("scroll", callbackFunc);
        } else {
            for (var i = 0; i < items.length; i++) {
                items[i].classList.add("in-view");
            }
        }

    }, []);
    const [workshop, setWorkshop] = React.useState(0)
    const workshops = [
        {
            type: "WORKSHOP 1",
            title: "Deep learning Introduction",
            trainer: "Nazim Bendib & Lilya Yahiaoui",
            trainerD: "School Of Ai Member | Master student at USTHB",
            source: img1,
            desc: " Through this workshop we will initiate participants in Deep learning and give them a road map to understanding Neuron Networks and theirs applications",
            date: "06-02-2021",
            hour: "14:30",
            duration: "3h",
            url: "https://meet.google.com/qdg-bwoi-yki",
            req: "no requirements needed.",

        },
        {
            type: "WORKSHOP 2",
            title: "Convolutional Neural Network",
            trainer: "Boudaoud Afif",
            trainerD: "Zindi Ambassdor, Ex vice-president of SOAI",
            source: img2,
            desc: "We will go through the fundamental concepts of computer vision and lead the participants to apply these concepts on a fun project that they will build from scratch during the workshop.",
            date: "06-02-2021",
            hour: "14:30",
            duration: "3h",
            url: "https://meet.google.com/csj-wxwi-mqi",
            req: "no requirements needed.",

        }, {
            type: "WORKSHOP 3",
            title: "Natural Language Processing",
            trainer: "MOHAMED HABI",
            trainerD: "Development Manager at SOAI",
            source: img3,
            desc: "The workshop talk about a specific application of NLP which is text style transfer. Through this workshop, participants will understand how to make a machine understand our natural languages (English, Arabic ...). In particular, how to analyze text data and transform a text from one style to another.",
            date: "06-02-2021",
            hour: "14:30",
            duration: "3h",
            url: "https://meet.google.com/wgo-hpit-ynw",
            req: "no requirements needed.",

        }, {
            type: "WORKSHOP 4",
            title: "Reinforcement Learning",
            trainer: "Azzeddine Chenine",
            trainerD: "AI Reaserch Engineer at InstaDeep",
            source: img4,
            desc: " In recent years, the emerging field of deep reinforcement learning has led to remarkable results in rich and varied domains like robotics, strategy games, and multi-agent interactions. This workshop will introduce the reinforcement learning algorithm and give participants the chance to practice in an interesting environment and grasp the concepts of deep q-learning.",
            date: "06-02-2021",
            hour: "14:30",
            duration: "3h",
            url: "https://meet.google.com/qxn-jgyr-smx",
            req: "no requirements needed.",

        }, {
            type: "Talk 1",
            title: "Processing Deep Learning on-chip",
            trainer: "Ghouthi Boukli Hacene",
            trainerD: "Postdoc at MILA Artificial intelligence",
            source: img6,
            desc: ' During the last decade, deep learning became state-of-the-art in many domains such as computer vision, speech recognition, and natural language processing. However, to achieve such a performance, deep learning algorithms require a large memory footprint and computational power. In this talk, we will present some works that aim at reducing deep learning complexity, memory usage, and energy consumption while keeping good performance.',
            date: "06-02-2021",
            hour: "18:30",
            duration: "30 min",
            url: "https://www.facebook.com/SchoolofAIAlgiers/",
            req: "no requirements needed.",

        },
        {
            type: "Talk 2",
            title: "Efficient NN Inference on Edge-Ai platforms",
            trainer: "Sofiane Yous",
            trainerD: "Leader of SW/HW co-design for Intel Edge-AI platforms",
            source: img9,
            desc: 'The complexity of Edge-AI platforms is rapidly increasing with the introduction of advanced inference features in order to achieve optimal inference in terms of compute and resource usage. Leveraging these complex features requires adaptation of the whole DNN (Deep Neuron Networks) inference development a deployment pipeline, from topology design through to deployment and inference runtime. This talk  will be about "Efficient NN Inference on Edge-AI Platforms" where our speaker "Sofiane Yous" will introduce these advanced HW and SW features and the associated challenges and opportunities in his talk',
            date: "06-02-2021",
            hour: "19:10",
            duration: "30 min",
            url: "https://www.facebook.com/SchoolofAIAlgiers/",
            req: "no requirements needed.",

        }
        ,
        {
            type: "Talk 3",
            title: "Privacy-Preserving Machine Learning ",
            trainer: "Ayoub Benaissa",
            trainerD: "Leader of the homomorphic encryption team at OpenMined",
            source: img8,
            desc: "The talk will be about Privacy-Preserving Machine Learning where we introduces the concept of privacy-preserving machine learning, by exploring the motivation behind it, and different use cases that need it, also introduces the concept of Homomorphic Encryption and how it can be used for ppml.",
            date: "06-02-2021",
            hour: "19:50",
            duration: "30 min",
            url: "https://www.facebook.com/SchoolofAIAlgiers/",
            req: "no requirements needed.",

        }, {
            type: "Talk 4",
            title: "Introduction Graph Neural Networks",
            trainer: "Abderaouf Gacem",
            trainerD: "PHD Candidate at LIRIS-INSA-Lyon",
            source: img5,
            desc: '  Molecules, Proteins, road maps, social networks are exciting things,they are all described by graphs.This talk will be about this stunning topic "Graph Deep Learning". Graph Deep Learning is a subfield of deep learning with the conception of Graph neural networks as main interest,aiming to extend the use of deep learning for graph datasets.',
            date: "06-02-2021",
            hour: "20:30",
            duration: "30 min",
            url: "https://www.facebook.com/SchoolofAIAlgiers/",
            req: "no requirements needed.",

        },
        {
            type: "",
            title: "Keynote: State of AI in 2020",
            trainer: "Hadjer Benmeziane",
            trainerD: "",
            source: img10,
            desc: 'It has become apparent that AI and deep learning have achieved many breakthroughs in computer vision, natural language and speech processing, and many are yet to come.  Like in the first edition of AI Day, we will discuss the most incredible applications that researchers and AI enthusiasts have created this past year? Do you have a favourite application ?',
            date: "06-02-2021",
            hour: "18:00",
            duration: "30 min",
            url: "https://www.facebook.com/SchoolofAIAlgiers/",
            req: "no requirements needed.",

        },
        {
            type: "",
            title: "Introduction to the workshops",
            desc: 'It has become apparent that AI and deep learning have achieved many breakthroughs in computer vision, natural language and speech processing, and many are yet to come.  Like in the first edition of AI Day, we will discuss the most incredible applications that researchers and AI enthusiasts have created this past year? Do you have a favourite application ?',
            date: "06-02-2021",
            hour: "18:00",
            duration: "30 min",
            url: "https://www.facebook.com/SchoolofAIAlgiers/",
            req: "no requirements needed.",

        },
        {
            type: "",
            title: "Open Debat",
            desc: 'It has become apparent that AI and deep learning have achieved many breakthroughs in computer vision, natural language and speech processing, and many are yet to come.  Like in the first edition of AI Day, we will discuss the most incredible applications that researchers and AI enthusiasts have created this past year? Do you have a favourite application ?',
            date: "06-02-2021",
            hour: "18:00",
            duration: "30 min",
            url: "https://meet.google.com/gai-rkfd-pvo",
            req: "no requirements needed.",

        },
    ];
    return (
        <div className="timeline-container">
            <div className="agenda-header" style={{
                textAlign: "center",
                fontFamily: 'Montserrat',
                color: "white",
                padding: "16px"
            }}>
                <h1 style={{ fontSize: "5.5rem !important", }}>Agenda</h1>
                <p style={{
                    fontSize: "2rem",
                    fontFamily: 'Montserrat',
                    color: "white",
                }}>Scroll down to see what's coming</p>




            </div>

            <div class="pop-container">

                <div class="popup" id="popup">
                    <div class="popup-inner " id="popup-inner">
                        {(workshop === 9 || workshop === 10) ? <div class="popup__text sc1" id="popup__text">
                            <div className="popup-container" >
                                <div className="centered" id="popup-text-container">
                                    <h1 style={{ color: "white", textAlign: "center", marginTop: "4%", marginBottom: 0 }} className="popup-text-title">{workshops[workshop].title}</h1>
                                </div>
                            </div>
                            <div style={{ marginTop: "2%" }} ref={domRef} className={"row-3" + ` fade-in-section ${isVisible ? 'is-visible' : ''}`}>
                                <div style={{ height: 110 }} className="row-elt">
                                    <h1>Date</h1>
                                    <h2>{workshops[workshop].date}</h2>
                                </div>
                                <div style={{ height: 110 }} className="row-elt">
                                    <h1>Hour</h1>
                                    <h2>{workshops[workshop].hour}</h2>
                                </div>
                                <div style={{ height: 110 }} className="row-elt" >
                                    <h1>Duration</h1>
                                    <h2>{workshops[workshop].duration}</h2>
                                </div>
                            </div>
                            <div ref={domRef1}></div>
                            {(workshop === 9) ? <Container className="faq-container">
                                <h1 style={{ color: "white" }}>Join us live on</h1>

                                <div className="followus-container">
                                    <a href="https://www.facebook.com/SchoolofAIAlgiers/" target="_blank" rel="noreferrer">
                                        <IconButton
                                            className="followus-btn" aria-label=" " component="span">
                                            <FacebookIcon />
                                        </IconButton>
                                    </a>
                                    <a href="https://www.instagram.com/school_of_ai.algiers/" target="_blank" rel="noreferrer">
                                        <IconButton
                                            className="followus-btn" aria-label=" " component="span">
                                            <InstagramIcon />
                                        </IconButton>
                                    </a>

                                    <a href="https://m.youtube.com/channel/UChFa3XnZYZ94tkjfJ5CnPOA" target="_blank" rel="noreferrer">
                                        <IconButton
                                            className="followus-btn" aria-label=" " component="span">
                                            <YouTubeIcon />
                                        </IconButton>
                                    </a>

                                </div>

                            </Container>
                                : <div className="test" style={{ height: 200, padding: "5%" }}>
                                    <div className="register-btn-container">
                                        <a style={{ borderRadius: 30 }} className="register-btn typeform-share button"
                                            href={workshops[workshop].url}
                                            data-mode="popup"

                                            data-size="100" >

                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                         JOIN NOW!
                    </a>

                                    </div>
                                </div>
                            }


                        </div>
                            : <div class="popup__text sc1" id="popup__text">
                                {
                                    /*<h1>{workshops[workshop].title}
                                <p>{workshops[workshop].text}</p>*/
                                }
                                <div className="popup-container" >
                                    { }
                                    <div className="popup-text-container" id="popup-text-container">
                                        <h1>{workshops[workshop].type}</h1>
                                        <h1 className="popup-text-title">{workshops[workshop].title}</h1>
                                        <h3>Presented by</h3>
                                        <Avatar className="trainer-img agenda-trainer" alt="Remy Sharp" src={workshops[workshop].source} />
                                        <h1>{workshops[workshop].trainer}</h1>
                                        <h2>{workshops[workshop].trainerD}</h2>
                                    </div>
                                    <div className="popup-image-container">
                                        <img className="popup-image" alt="" src={workshops[workshop].source} />
                                    </div>
                                </div>
                                <div ref={domRef} className={"row-3" + ` fade-in-section ${isVisible ? 'is-visible' : ''}`}>
                                    <div className="row-elt">
                                        <h1>Date</h1>
                                        <h2>{workshops[workshop].date}</h2>
                                    </div>
                                    <div className="row-elt">
                                        <h1>Hour</h1>
                                        <h2>{workshops[workshop].hour}</h2>
                                    </div>
                                    <div className="row-elt" >
                                        <h1>Duration</h1>
                                        <h2>{workshops[workshop].duration}</h2>
                                    </div>
                                </div>
                                <div ref={domRef1} className={"row-2" + ` fade-in-section ${isVisible1 ? 'is-visible' : ''}`}>
                                    {(workshop === 5 || workshop === 6 || workshop === 7 || workshop === 8 || workshop === 4) ?
                                        <div style={{ width: "100%" }} className="row-2-elt" >
                                            <h1 style={{ textAlign: "center" }}>Description</h1>
                                            <h2 style={{ textAlign: "center" }}>{workshops[workshop].desc}
                                            </h2>
                                        </div> :
                                        <div className="row-2-elt" >
                                            <h1>Description</h1>
                                            <h2>{workshops[workshop].desc}
                                            </h2>
                                        </div>
                                    }
                                    {(workshop === 5 || workshop === 6 || workshop === 7 || workshop === 8 || workshop === 4) ?
                                        <div style={{ display: "none" }} className="row-2-elt" id="row-2-elt-left">
                                            <h1>Requirement</h1>
                                            <h2></h2> : <h2>{workshops[workshop].req}</h2>


                                        </div>
                                        :
                                        <div className="row-2-elt" id="row-2-elt-left">
                                            <h1>Requirement</h1>
                                            <h2></h2> : <h2>{workshops[workshop].req}</h2>


                                        </div>}

                                </div>
                                <div className="test" style={{ height: 200, padding: "5%" }}>
                                    <div className="register-btn-container">
                                        <a style={{ borderRadius: 30 }} className="register-btn typeform-share button"
                                            href={workshops[workshop].url}
                                            data-mode="popup"

                                            data-size="100" >

                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                 JOIN NOW!
                            </a>

                                    </div>
                                </div>
                            </div>}

                        <a class="popup__close" onClick={() => {
                            var element = document.getElementById("popup");
                            element.classList.remove("popup-target");
                        }}>X</a>
                    </div>
                </div>
            </div>
            <section className="timeline">
                <ul>
                    <li className="list-item">
                        <div className="list-item-div">
                            <div class="card">
                                <div class="img-avatar" id="img10">
                                </div>
                                <div class="card-text">

                                </div>
                                <div class="title-total">
                                    <div class="title" id="long-name1" >Via Google Meet</div> <div class="title-time">At 11:00</div>
                                    <h2>Open Debat</h2>
                                    <div class="desc">  <button class="pop-button" onClick={() => {
                                        setWorkshop(10);

                                        var element = document.getElementById("popup");
                                        element.classList.add("popup-target");
                                    }} > Show details</button></div>

                                </div>

                            </div>
                        </div>
                    </li>
                    <li className="list-item">
                        <div className="list-item-div">
                            <div class="card">
                                <div class="img-avatar" id="img10">
                                </div>
                                <div class="card-text">

                                </div>
                                <div class="title-total">
                                    <div class="title" id="long-name1" >Live on our social media</div> <div class="title-time">At 14:00</div>
                                    <h2 id="NLP">Introduction to the workshops</h2>
                                    <div class="desc">
                                        <button class="pop-button" onClick={() => {
                                            setWorkshop(9);

                                            var element = document.getElementById("popup");
                                            element.classList.add("popup-target");
                                        }} > Show details</button> </div>

                                </div>

                            </div>
                        </div>
                    </li>
                    <li className="list-item">
                        <div className="list-item-div">
                            <div class="card">
                                <div class="img-avatar" id="img1">
                                </div>
                                <div class="card-text">

                                </div>
                                <div class="title-total">
                                    <div id="long-name1" class="title">Nazim Bendib/ Lilya Yahiaoui</div> <div class="title-time">At 14:30</div>
                                    <h2 id="DL">Deeplearning Introduction</h2>
                                    <div class="desc">  <button class="pop-button" onClick={() => {
                                        setWorkshop(0);
                                        var elem = document.getElementById("popup-text-container");
                                        elem.scrollIntoView();
                                        var element = document.getElementById("popup");
                                        element.classList.add("popup-target");
                                    }} > Show details</button></div>

                                </div>

                            </div>
                        </div>
                    </li>
                    <li className="list-item">
                        <div className="list-item-div">
                            <div class="card">
                                <div class="img-avatar" id="img2">
                                </div>
                                <div class="card-text">

                                </div>
                                <div class="title-total">
                                    <div class="title">Afif Boudaoud </div><div class="title-time">At 14:30</div>
                                    <h2 id="CNN">CNN Workshop</h2>
                                    <div class="desc"> <button class="pop-button" onClick={() => {
                                        setWorkshop(1);
                                        var elem = document.getElementById("popup-text-container");
                                        elem.scrollIntoView(); var element = document.getElementById("popup");
                                        element.classList.add("popup-target");
                                    }} > Show details</button></div>

                                </div>
                            </div>

                        </div>
                    </li>
                    <li className="list-item">
                        <div className="list-item-div">
                            <div class="card">
                                <div class="img-avatar" id="img3">
                                </div>
                                <div class="card-text">
                                </div>
                                <div class="title-total">
                                    <div class="title">MOHAMED HABI</div><div class="title-time">At 14:30</div>
                                    <h2 id="NLP">Natural Language Processing</h2>
                                    <div class="desc"> <button class="pop-button" onClick={() => {
                                        setWorkshop(2);
                                        var elem = document.getElementById("popup-text-container");
                                        elem.scrollIntoView(); var element = document.getElementById("popup");
                                        element.classList.add("popup-target");
                                    }} > Show details</button></div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li className="list-item">
                        <div className="list-item-div">
                            <div class="card">
                                <div class="img-avatar" id="img4">
                                </div>
                                <div class="card-text">
                                </div>
                                <div class="title-total" >
                                    <div id="long-name" class="title">Azzeddine Chenine</div><div class="title-time">At 14:30</div>
                                    <h2 id="RL">Reinforcement Learning</h2>
                                    <div class="desc"><button class="pop-button" onClick={() => {
                                        setWorkshop(3);
                                        var elem = document.getElementById("popup-text-container");
                                        elem.scrollIntoView(); var element = document.getElementById("popup");
                                        element.classList.add("popup-target");
                                    }} > Show details</button></div>
                                </div>
                            </div>
                        </div>
                    </li>


                    <li className="list-item">
                        <div className="list-item-div">
                            <div class="card">
                                <div class="img-avatar" id="img9">
                                </div>
                                <div class="card-text">
                                </div>
                                <div class="title-total">
                                    <div id="long-name" class="title">Hadjer Benmeziane</div><div class="title-time">At 18:00</div>
                                    <h2 id="keynote">Keynote: State of AI in 2020</h2>
                                    <div class="desc"> <button class="pop-button" onClick={() => {
                                        setWorkshop(8);
                                        var elem = document.getElementById("popup-text-container");
                                        elem.scrollIntoView(); var element = document.getElementById("popup");
                                        element.classList.add("popup-target");
                                    }} > Show details</button></div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li className="list-item">
                        <div className="list-item-div">
                            <div class="card">
                                <div class="img-avatar" id="img6">
                                </div>
                                <div class="card-text">
                                </div>
                                <div class="title-total">
                                    <div id="long-name" class="title">Ghouthi Boukli Hacene</div><div class="title-time">At 18:30</div>
                                    <h2 id="NLP">Processing Deep Learning on-chip</h2>
                                    <div class="desc"> <button class="pop-button" onClick={() => {
                                        setWorkshop(4);
                                        var elem = document.getElementById("popup-text-container");
                                        elem.scrollIntoView(); var element = document.getElementById("popup");
                                        element.classList.add("popup-target");
                                    }} > Show details</button></div>
                                </div>
                            </div>
                        </div>
                    </li>

                    <li className="list-item">
                        <div className="list-item-div">
                            <div class="card">
                                <div class="img-avatar" id="img8">
                                </div>
                                <div class="card-text">
                                </div>
                                <div class="title-total">
                                    <div class="title">Sofiane Yous</div><div class="title-time">At 19:10</div>
                                    <h2 id="EdgeAi">Efficient NN Inference on Edge-Ai platforms </h2>
                                    <div class="desc"> <button class="pop-button" onClick={() => {
                                        setWorkshop(5);
                                        var elem = document.getElementById("popup-text-container");
                                        elem.scrollIntoView(); var element = document.getElementById("popup");
                                        element.classList.add("popup-target");
                                    }} > Show details</button></div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li className="list-item">
                        <div className="list-item-div">
                            <div class="card">
                                <div class="img-avatar" id="img7">
                                </div>
                                <div class="card-text">
                                </div>
                                <div class="title-total">
                                    <div class="title">Ayoub Benaissa</div><div class="title-time">At 19:50</div>
                                    <h2 id="NLP">Privacy-Preserving Machine Learning</h2>
                                    <div class="desc"> <button class="pop-button" onClick={() => {
                                        setWorkshop(6);
                                        var elem = document.getElementById("popup-text-container");
                                        elem.scrollIntoView(); var element = document.getElementById("popup");
                                        element.classList.add("popup-target");
                                    }} > Show details</button></div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li className="list-item">
                        <div className="list-item-div">
                            <div class="card">
                                <div class="img-avatar" id="img5">
                                </div>
                                <div class="card-text">

                                </div>
                                <div class="title-total">
                                    <div class="title">Abderaouf Gacem</div><div class="title-time">At 20:30</div>
                                    <h2 id="GNN">Graph Neural Networks</h2>
                                    <div class="desc"> <button class="pop-button" onClick={() => {
                                        setWorkshop(7);
                                        var elem = document.getElementById("popup-text-container");
                                        elem.scrollIntoView(); var element = document.getElementById("popup");
                                        element.classList.add("popup-target");
                                    }} > Show details</button></div>
                                </div>
                            </div>
                        </div>
                    </li>


                    {/* <li className="list-item">
                        <div className="list-item-div">
                            <div class="card">
                                <div class="img-avatar" id="img9">
                                </div>
                                <div class="card-text">
                                </div>
                                <div class="title-total">
                                    <div class="title">Boudaoud Afif</div><div class="title-time">à 13:00</div>
                                    <h2>CNN Workshop</h2>
                                    <div class="desc">Join the workshop here ...</div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li className="list-item">
                        <div className="list-item-div">
                            <div class="card">
                                <div class="img-avatar" id="img1">
                                </div>
                                <div class="card-text">
                                </div>
                                <div class="title-total">
                                    <div class="title">Boudaoud Afif</div><div class="title-time">à 13:00</div>
                                    <h2>CNN Workshop</h2>
                                    <div class="desc">Join the workshop here ...</div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li className="list-item">
                        <div className="list-item-div">
                            <div class="card">
                                <div class="img-avatar" id="img1">
                                </div>
                                <div class="card-text">
                                </div>
                                <div class="title-total">
                                    <div class="title">Boudaoud Afif</div><div class="title-time">à 13:00</div>
                                    <h2>CNN Workshop</h2>
                                    <div class="desc">Join the workshop here ...</div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li className="list-item">
                        <div className="list-item-div">
                            <div class="card">
                                <div class="img-avatar" id="img1">
                                </div>
                                <div class="card-text">
                                </div>
                                <div class="title-total">
                                    <div class="title">Boudaoud Afif</div> <div class="title-time">à 13:00</div>
                                    <h2>CNN Workshop</h2>
                                    <div class="desc">Join the workshop here ...</div>
                                </div>
                            </div>
                        </div>
                    </li> 
                    
                    */ }



                </ul>
            </section>

        </div>

    )
}